<template>
    <v-sheet>
        <!--div class="d-flex mt-2 flex-grow-1 flex-shrink-0 align-center justify-space-around">
            <v-label>Filtra</v-label>
            <v-autocomplete dense outlined
                class="ml-4"
                :items=Object.keys(families)
                append-icon="filter_list"
                clearable
                hide-details
                v-model="search_family"
                label="famiglia">
                </v-autocomplete>
                <v-autocomplete dense outlined
                class="ml-2"
                :items=Object.values(op_types)
                apepend-icon="filter_list"
                item-text="name"
                item-value="id"
                clearable
                hide-details
                v-model="search_report"
                label="report">
            </v-autocomplete>
            <v-btn class="ml-6" color="primary" @click="searchMasters"><v-icon small>search</v-icon></v-btn>
            <v-btn class="ml-2" color="action" @click="clearSearch"><v-icon small>clear</v-icon></v-btn>
        </div-->
        <BasicCard>
            <template v-slot:action>
                <v-btn v-can="{obj_type:'category', action: 'edit'}" class="ml-2 white--text" text @click.stop="editCategory(null)"><v-icon class="pa-2" small>add_box</v-icon> Nuovo set di prove</v-btn>
            </template>
            <div v-if="loading" class="d-flex justify-center">
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </div>
            <v-data-table
                v-else
                :headers="headers"
                :items="categories"
                hide-default-footer
                disable-pagination
                >
                <template v-slot:body="{ items }">
                <tbody>
                    <tr class="cursor_pointer" v-for="item of items" :key="item._id+'_'+item._rev" @click.stop="viewCategory(item._id)">
                        <td class="text-left">{{item.name}}</td>
                        <td class="text-left">{{families[item.family].label}}</td>
                        <td class="text-left">{{item.uom}}</td>
                        <td class="text-left">{{item.updated | formatDateTS}}</td>
                        <td class="text-right">
                            <div class="d-flex align-center justify-end">
                                <v-btn v-can="{obj_type:'category', action: 'edit'}" color="primary" class="ma-1" small fab @click.stop="editCategory(item._id)"><v-icon small>edit</v-icon></v-btn>
                                <v-btn v-can="{obj_type:'category', action: 'remove'}" :disabled="notDeletable(item._id)" color="primary" class="ma-1" small fab @click.stop="openDeleteConfirm(item)"><v-icon small>delete</v-icon></v-btn>
                            </div>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-data-table>
        </BasicCard>
         <ConfirmDialog
            v-bind:data="delete_confirm"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onDeleteConfirm"/>
    </v-sheet>
</template>
<script>
import BasicCard from '../../components/utils/Basic_card'
import {i_families} from "../../utils/common.js"
import {formatDatefromTS} from "../../utils/commonUtils"
import { searchDesign } from "../../utils/dbUtility"
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
// // import _ from 'lodash'
export default {
    components:{BasicCard, ConfirmDialog},
    data() {
        return {
            headers: [
                {text: 'nome', value: 'name', align:'left', sortable: false},
                {text: 'famiglia', value: 'family', align:'left', sortable: false},
                {text: 'unità di misura', value: 'uom', align: 'left', sortable: false},
                {text: 'aggiornato il', value: 'updated', align:'left', sortable: false},
                {text: '', value: '', align:'left', sortable: false}
            ],
            families: i_families,
            loading: true,
            categories: [],
            used_cats: [],
            delete_confirm: {
                dialog: false,
                cat: null,
                title: 'Cancella set di prove',
                message: "Sei sicuro di voler eliminare il set di prove selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
            },
            search_family: ""
        }
    },
    methods: {
        
        async searchCategories(){
            let selector = {doc_type: 'category'}
            let res = await this.$store.state.$pouch.find('masters', {
                selector: selector
            })
            let instr_cat = await searchDesign(this.$store.state.$pouch, "registry", "instruments/searchByData", "range", [["category"], ["category",{}]], true)
            this.used_cats = _.uniq(_.map(instr_cat, (instr) => {
                    return instr.key[1]
            }))
            console.log("INSTRUMENTS CAT", this.used_cats)
            this.categories = res.docs
            this.loading = false
        },
        editCategory(c_id){
            this.$router.push({name: "editCategory", query: {c_id: c_id, clone: "false"}})
        },
        viewCategory(c_id){
            this.$router.push({name: "viewCategory", query: {c_id: c_id, clone: "false", preview: "true"}})
        },
        formatDate(ts){
            return formatDatefromTS(ts)
        },
        notDeletable(cat_id) {
            return this.used_cats.includes(cat_id)
        },
        openDeleteConfirm(cat){
            this.delete_confirm.cat = cat
            this.delete_confirm.dialog = true;
        },
        async onDeleteConfirm(choice){
            try {
                if(choice == "delete"){
                    this.delete_confirm.cat.updated_by = this.$store.state.user._id
                    this.delete_confirm.cat.updated = (new Date()).getTime()
                    this.delete_confirm.cat._deleted = true
                    let res = await this.$store.state.$pouch.put('masters', this.delete_confirm.cat)
                    if (res.ok) {
                        this.searchCategories()
                    }
                } 
                this.closeDialog()
            } catch (error) {
                console.log('error DELETE CAT', error)
            }
        },
        closeDialog(){
            this.delete_confirm.dialog = false;
        },

    },
    mounted(){
        this.searchCategories()
    }
}
</script>